/**
 * Darf die Mitteilung der Prüfungsleitung jetzt erscheinen? Sie wartet in zwei Momenten und
 * kommt danach von selbst — sie bleibt in `useAufsichtStore.offen`.
 *
 * - **Bogenabzug** (`shotStamp`): das Beweisbild zeigt, was auf dem Schirm steht. `abzug`
 *   räumt dafür Blatt und Wechselfrage weg; eine Mitteilung darauf wäre derselbe Fehler — und
 *   ihr Text kann Namen tragen.
 * - **Scanbühne** (`sheet.kind === 'scanner'`): sie liegt nicht im Portal und über den
 *   Dialogen (z-index 10). Der Dialog läge darunter, und weil Radix dem Body die Berührung
 *   nimmt, nähmen auch ihre Knöpfe nichts mehr an — die Bühne stünde eingefroren da.
 */
export function mitteilungZeigen(s: { shotStamp: string | null; sheetKind: string }): boolean {
  return s.shotStamp === null && s.sheetKind !== 'scanner';
}
